import {
  Directive,
  ElementRef,
  OnDestroy,
  OnInit
} from '@angular/core';

import { KEYCODES } from '../core/constants/core.keycodes.constant';

@Directive({
  selector: '[filter]'
})
export class GridFilterDirective implements OnInit, OnDestroy {
  private keydownHandler: ( e: KeyboardEvent ) => void;
  private clearHandler  : ( e: Event ) => void;

  constructor ( private el: ElementRef ) {}

  ngOnInit () : void {
    const element  = $(this.el.nativeElement);
    const maxLength = 50;

    element.attr('maxlength', maxLength);

    this.clearHandler = () => {
      element.val('');
      element.trigger('input');
    };

    this.keydownHandler = ( e: KeyboardEvent ) => {
      if (e.keyCode === KEYCODES.esc) {

        this.clearHandler(e);

        e.stopPropagation();

      }
    };

    element.on('keydown', this.keydownHandler as any);

    element.siblings()
      .find('a')
      .on('click', this.clearHandler as any);
  }

  ngOnDestroy () : void {


    const element = $(this.el.nativeElement);

    element.off('keydown', this.keydownHandler as any);

    element.siblings()
      .find('a')
      .off('click', this.clearHandler as any);


  }
}
